const ObjectCleaner = (obj) => {
  for (let propName in obj) {
    if (!obj[propName]) {
      delete obj[propName]
    }
  }
  return obj
}

export default ObjectCleaner



// WEBPACK FOOTER //
// ./src/Utils/ObjectCleaner.js